module.exports = {
  locales: ['default', 'de', 'en', 'fr', 'it', 'zh', 'ko', 'th'],
  defaultLocale: 'default',
  pages: {
    '*': ['common'],
  },
};
